import './triangular.module';

import './settings.provider';

import './components';
import './themes';

import './variables.scss';
import './triangular.scss';

import './scss/components/_footer.scss';
import './scss/components/_loader.scss';
import './scss/components/_menu.scss';
import './scss/components/_notifications-panel.scss';
import './scss/components/_toolbar.scss';
import './scss/layouts/states/_triangular.scss';
import './scss/layouts/_default.scss';
import './scss/_contextual.scss';
import './scss/_dialogs.scss';
import './scss/_material-overrides.scss';
import './scss/_print.scss';
import './scss/_reset.scss';
import './scss/_social.scss';
import './scss/_tables.scss';
import './scss/_typography.scss';
import './scss/_utilities.scss';
